import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { AuthProvider } from './features/auth/AuthProvider'
import { registerPwaUpdates } from './features/update/pwaUpdate'
import { restoreFontSizePreference } from './features/display/fontSizePreference'
import { appBasePath } from './shared/publicPath'
import './styles/global.css'

restoreFontSizePreference()

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => { void registerPwaUpdates() })
}

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter></StrictMode>)
